import useBrand from '@/hooks/useBrand';
import useNavigate from '@/hooks/useNavigate';
import getEnv from '@/utils/env';
import { FC, useEffect } from 'react';

const Import: FC = () => {
  const navigate = useNavigate();
  const brand = useBrand();

  useEffect(() => {
    const env = getEnv();
    if (env.PROFIL == 'PF') {
      navigate('societe');
      window.history.replaceState(
        {},
        document.title,
        '/#/' + brand.get() + '/societe',
      );
    } else {
      navigate('menu');
      window.history.replaceState(
        {},
        document.title,
        '/#/' + brand.get() + '/menu',
      );
    }
  }, [, window.location, location]);

  return <></>;
};

export default Import;
